import { useThemeColors } from "../hooks/useThemeColors";

const CockpitIcon = ({ active, category, themeColor }) => {
  const width = category ? "68" : "28";
  const height = category ? "67" : "27";
  const { PRIMARY_COLOR } = useThemeColors();
  const stroke = active ? PRIMARY_COLOR : category ? "#D0D0D0" : themeColor || "#000000";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M3 2.5V23.5H24.5"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.5"
        y="14"
        width="4.5"
        height="7"
        rx="0.9"
        stroke={stroke}
        strokeWidth="2"
      />
      <rect
        x="13.25"
        y="10"
        width="4.5"
        height="11"
        rx="0.9"
        stroke={stroke}
        strokeWidth="2"
      />
      <rect
        x="20"
        y="6"
        width="4.5"
        height="15"
        rx="0.9"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};

export default CockpitIcon;
